import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tableBody"];

  sortByColumn(event) {
    const field = event.currentTarget.dataset.field;
    const direction = this.toggleSortDirection(event.currentTarget);

    this.updateSortIcons(event.currentTarget, direction);
    this.performColumnSort(field, direction);
  }

  toggleSortDirection(element) {
    const currentDirection = element.dataset.direction || 'none';

    if (currentDirection === 'asc') {
      element.dataset.direction = 'desc';
      return 'desc';
    } else {
      element.dataset.direction = 'asc';
      return 'asc';
    }
  }

  updateSortIcons(clickedHeader, direction) {
    document.querySelectorAll(".sortable-header").forEach(header => {
      const icon = header.querySelector("i");
      if (icon && header !== clickedHeader) {
        icon.className = "fa fa-fw fa-sort";
        header.dataset.direction = 'none';
      }
    });

    const icon = clickedHeader.querySelector("i");
    if (icon) {
      icon.className = `fa fa-fw fa-sort-${direction === "asc" ? "up" : "down"}`;
    }
  }

  performColumnSort(field, direction) {
    const rows = Array.from(this.tableBodyTarget.querySelectorAll('tr'));

    rows.sort((a, b) => {
      let aValue = this.getCellValue(a, field);
      let bValue = this.getCellValue(b, field);

      // Handle numeric comparisons
      if (this.isNumeric(aValue) && this.isNumeric(bValue)) {
        return direction === 'desc' ? bValue - aValue : aValue - bValue;
      }

      // Handle string comparisons
      if (aValue < bValue) return direction === 'desc' ? 1 : -1;
      if (aValue > bValue) return direction === 'desc' ? -1 : 1;
      return 0;
    });

    this.tableBodyTarget.innerHTML = '';
    rows.forEach(row => this.tableBodyTarget.appendChild(row));
  }

  getCellValue(row, field) {
    let cellIndex;
    switch(field) {
      case 'name': cellIndex = 0; break;
      case 'pulse_score': cellIndex = 1; break;
      case 'score_change': cellIndex = 2; break;
      case 'response_rate': cellIndex = 3; break;
      case 'response_rate_change': cellIndex = 4; break;
      default: cellIndex = 0;
    }

    const cell = row.cells[cellIndex];
    if (!cell) return '';

    let text = cell.textContent.trim();

    // Handle name field - look for account name
    if (field === 'name') {
      const accountLink = cell.querySelector('.account-link');
      return accountLink ? accountLink.textContent.trim().toLowerCase() : text.toLowerCase();
    }

    // Handle empty/N/A values - sort to bottom
    if (text === 'N/A' || text === '—' || text === '') {
      return -999;
    }

    // Extract numeric values from text
    const numberMatch = text.match(/[-+]?[\d.,]+/);
    if (numberMatch) {
      return parseFloat(numberMatch[0].replace(',', ''));
    }

    return text.toLowerCase();
  }

  isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }
}
